import Roles from "@/utils/roles"
import { exibeSugestoesConteudo } from "@/utils/sugestoes-conteudo"

// A role é a mesma para todo cliente, então esconder o item de menu não basta: sem este
// guard o cliente de plano sem sugestões ainda chegaria na tela digitando a URL.
const bloquearSemSugestoes = (to, from, next) => {
  if (!exibeSugestoesConteudo()) {
    next({ name: 'home' })
    return
  }
  next()
}

export default [
  {
    path: "/minhas-sugestoes",
    name: "minhas-sugestoes-conteudo",
    component: () => import("@/views/area-cliente/sugestoes-conteudo/index.vue"),
    meta: {
      title: 'Sugestões de Conteúdo',
      authRequired: true,
      roles: [Roles.LerMinhasSugestoes]
    },
    beforeEnter: bloquearSemSugestoes,
  },
  {
    path: "/minhas-sugestoes/ver/:id",
    name: "minha-sugestoes-view",
    component: () => import("@/views/area-cliente/sugestoes-conteudo/form.vue"),
    meta: {
      title: 'Sugestões de Conteúdo',
      authRequired: true,
      roles: [Roles.LerMinhasSugestoes]
    },
    beforeEnter: bloquearSemSugestoes,
  },
];
